import React, { useEffect } from 'react'
import { HotelListingVIPBanner } from '@pcln/bundle-and-save-components'
import { Box } from 'pcln-design-system'
import { handleComponentLoaded, handleClick } from './helper'
import styled from 'styled-components'

const VipBannerWrapper = styled(Box)`
  ${(props) =>
    props.isSignedIn &&
    `
      div[data-testid="bannerContents"] > div > div > div {
        font-size: 16px;

        ${props.theme.mediaQueries.lg} {
          font-size: 18px;
        }
      }
    `}
`

export const PackagesVIPBanner = (props) => {
  const { isSignedIn = false } = props

  useEffect(() => {
    //fire view ga4 event
    handleComponentLoaded(isSignedIn)
  }, [isSignedIn])

  return (
    <VipBannerWrapper px={[2, 2, 2, 2, 0]} {...props}>
      <HotelListingVIPBanner isSignedIn={isSignedIn} onVIPBannerClick={(e) => handleClick(e)} />
    </VipBannerWrapper>
  )
}
